// extracted by mini-css-extract-plugin
export default {"row":"eILVEs","colTicket":"ape3Pp","colSeatInfo":"Ws0p7H","colTotal":"Y6D_86"};